import React from 'react';
import { PromptCreativityContent } from 'src/types/banner';
import { ChatMessage } from '../../../../types/brands';

interface UseAITypingProps {
  creativity: PromptCreativityContent;
  localWaitingForResponse: boolean;
  setLocalWaitingForResponse: (waiting: boolean) => void;
  messages: ChatMessage[];
  isSending: boolean;
}

export const useAITyping = ({
  creativity,
  localWaitingForResponse,
  setLocalWaitingForResponse,
  messages,
  isSending
}: UseAITypingProps) => {
  const [showTyping, setShowTyping] = React.useState(false);
  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  React.useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (isSending) {
      setShowTyping(false);
      return;
    }

    const lastMessage = messages[messages.length - 1];

    // Reset cuando llega IA
    if (lastMessage?.type === 'ai' && localWaitingForResponse) {
      setLocalWaitingForResponse(false);
      setShowTyping(false);
      return;
    }

    // Mostrar typing basado en MÚLTIPLES condiciones
    const bannerProcessing =
      creativity.status === 'PENDING' || creativity.status === 'IN_PROGRESS' || creativity.status === 'PROCESSING_IA';

    const lastMessageIsUser = lastMessage?.type === 'user';

    const shouldShowTyping = (localWaitingForResponse || bannerProcessing) && lastMessageIsUser;

    if (shouldShowTyping) {
      setShowTyping(true); // Sin delay
    } else {
      setShowTyping(false);
    }
  }, [creativity.status, localWaitingForResponse, messages, isSending, setLocalWaitingForResponse]);

  // Cleanup al desmontar
  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return showTyping;
};
